import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* --- Global CSS --- */
import './styles/tokens.css';
import './styles/buttons.css';
import './styles/animations.css';   // ★ 追加
import './index.css';

import { RouterProvider } from 'react-router-dom';
import router from './routes';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { stripLangQuery } from '@/i18n/detect';
import { setupAnalytics } from '@/utils/analytics';


stripLangQuery();
setupAnalytics(router);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  </StrictMode>,
);
